import { useLang } from '@/i18n';
// import gtm from '@/utils/gtm';
import css from './index.module.scss';
import { icon1, icon2, icon3, icon4, linkBtn } from './icons';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { useEffect, useState } from 'react';
import { useProductPageStatus } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import { useRouter } from 'next/router';

interface IconType {
    text: string;
    icon: React.ReactNode;
}
interface ItemType {
    name: string;
    text?: string;
    img: string[];
    mark: string;
    icons?: IconType[];
    gtmTitle: string;
    webp: string[];
}

const C: React.FC = () => {
    const { t } = useLang('dpux');
    const webpOrJpg = useWebpOrJpg('#delta-pro-ultra-x-C');
    const [enter, setEnter] = useState(false);
    const { locale = '' } = useRouter();
    const pageStatus = useProductPageStatus();
    const items: ItemType[] = [
        {
            name: t.rich('C_box1_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            text: t.rich('C_box1_text', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1758939590762/pc_KSP_1.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758939652214/m_KSP_1.jpg',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1758939479577/pc_KSP_1.webp',
                'https://websiteoss.ecoflow.com/upload/image/1758939480867/m_KSP_1.webp',
            ],
            mark: locale === 'ca' ? '#delta-pro-ultra-x-H' : '#delta-pro-ultra-x-J',
            gtmTitle: t('J_title'),
        },
        {
            name: t.rich('C_box2_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            text: t('C_box2_text'),
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1760080387660/pc_KSP_2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1760080388191/m_KSP_2.jpg',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1760080464537/pc_KSP_2.webp',
                'https://websiteoss.ecoflow.com/upload/image/1760080464192/m_KSP_2.webp',
            ],
            mark: '#delta-pro-ultra-x-G',
            gtmTitle: t('G_title'),
        },
        {
            name: t.rich('C_box3_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            text: t('C_box3_text'),
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1759045179842/C_pc_KSP_3.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1760000709009/m_KSP_3.jpg',
            ],
            webp: ['', ''],
            mark: '#delta-pro-ultra-x-I',
            gtmTitle: t('I_title'),
        },
        {
            name: t.rich('C_box4_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            text: t('C_box4_text'),
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1760080387492/pc_KSP_4.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1760080388002/m_KSP_4.jpg',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1760080463833/pc_KSP_4.webp',
                'https://websiteoss.ecoflow.com/upload/image/1760080463966/m_KSP_4.webp',
            ],
            mark: '#delta-pro-ultra-x-NumberAni',
            gtmTitle: t('NumberAni.title'),
        },
        {
            name: t.rich('C_box5_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            text: t('C_box5_text'),
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1758939591084/pc_KSP_5.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758939651332/m_KSP_5.jpg',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1758939478798/pc_KSP_5.webp',
                'https://websiteoss.ecoflow.com/upload/image/1758939480014/m_KSP_5.webp',
            ],
            mark: '#delta-pro-ultra-x-H',
            gtmTitle: t('H_title'),
        },
        {
            name: t.rich('C_box6_name', {
                s: (v: string) => <span className="s">{v}</span>,
            }),
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1758939590854/pc_KSP_6.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758939651121/m_KSP_6.jpg',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1758939478558/pc_KSP_6.webp',
                'https://websiteoss.ecoflow.com/upload/image/1758939479780/m_KSP_6.webp',
            ],
            mark: '#delta-pro-ultra-x-Tabs',
            icons: [
                {
                    text: t('C_box6_icon1'),
                    icon: icon1,
                },
                {
                    text: t('C_box6_icon2'),
                    icon: icon2,
                },
                {
                    text: t('C_box6_icon3'),
                    icon: icon3,
                },
                {
                    text: t('C_box6_icon4'),
                    icon: icon4,
                },
            ],
            gtmTitle: t('Tabs.title'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneCArr: any[] = [];
            const info: HTMLElement | null = document.querySelector('.delta-pro-ultra-x-C .info');
            if (info) {
                sceneCArr.push(
                    AniContainer.create({
                        triggerElement: '.delta-pro-ultra-x-C .info',
                        triggerHook: 1,
                        offset: '20%',
                        duration: '100%',
                        onEnter: () => setEnter(true),
                        onProcess: (process: number) => {
                            if (process <= 0) {
                                setEnter(false);
                            }
                        },
                    }),
                );
            }
            return () => {
                sceneCArr.forEach((item: any) => item.destroy());
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} delta-pro-ultra-x-C GtmModuleData-section ${pageStatus === IPageStatus.REGULAR ? 'hide-D' : ''}`}
            id="delta-pro-ultra-x-C"
            data-section-id={'delta-pro-ultra-x-C'}
            data-section-title={t('C_title')}
        >
            <div className={`info${enter ? ' enter' : ''}`}>
                <p className="title">{t('C_title')}</p>
            </div>
            <div className={`items ${enter ? 'enter' : ''}`}>
                {items.map((item: ItemType, k: number) => (
                    <EcoLink
                        key={item.name}
                        className={`item item-${k + 1} GtmModuleData-btn-href`}
                        href={item.mark}
                        style={{ gridArea: `g${k + 1}` }}
                        onClick={() => {
                            // 当前滚动距离
                            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                            window.sessionStorage.setItem('toTop-scrollTop', scrollTop.toString());
                        }}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'click_anchor',
                            position: item.gtmTitle,
                            button_name: item.name,
                            __btn_id1: css.section,
                            __btn_id2: item.mark,
                        }}
                    >
                        <div className="item-ani">
                            <EcoImg className="item-img" pc={webpOrJpg(item.img[0], item.webp[0])} h5={webpOrJpg(item.img[1], item.webp[1])} />
                            <div className="item-info">
                                <p className="item-name">{item.name}</p>
                                {item?.text && <p className="item-text">{item.text}</p>}
                                <div className="item-icons">
                                    {item?.icons?.map((icon: IconType) => (
                                        <div key={icon.text} className="item-icon">
                                            {icon.icon}
                                            <p className="item-icon-text">{icon.text}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <span className="item-link"></span>
                        </div>
                    </EcoLink>
                ))}
            </div>
            {locale === 'ca' && <p className={`footer ${enter ? 'enter' : ''}`}>{t('item_Remarks')}</p>}
        </section>
    );
};

export default C;
